var _clientEvaluationLanguages;
var _userClientEvaluationLanguages;

$(document).ready(function () {

    setTable();

});

function showUserToModify(userId, userFirstName, userLastName, userPhoneNumber, userEmail, userRole, userRoleName, userLanguage, userTimezone, userClient, defaultLanguage, userClientEvaluationLanguages, clientEvaluationLanguages) {
    _clientEvaluationLanguages = clientEvaluationLanguages;

    userClientEvaluationLanguages = eval(userClientEvaluationLanguages);
    _userClientEvaluationLanguages = userClientEvaluationLanguages;

    $("#firstNameToModify").val(userFirstName);
    $("#lastNameToModify").val(userLastName);
    $("#phoneNumberToModify").val(userPhoneNumber);
    $("#emailToModify").val(userEmail);
    $("#roleToModify").val(userRole);
    $("#languageToModify").val(userLanguage);

    $('input[name="languagesToModify"]').prop("checked", false);
    $('input[name="defaultLanguagesToModify"]').prop("checked", false);
    $('input[name="defaultLanguagesToModify"]').addClass("d-none");
    $('.optional-languagesToModify-radio-labels').addClass("d-none");
    $('.default-languagesToModify-radio-labels').addClass("d-none");

    if (userRoleName == 'eval') {
        $('#evaluationTreeToModify').show();
    } else {
        $('#evaluationTreeToModify').hide();
    }

    $.each(JSON.parse(userLanguage), function (index, value) {

        $('input[name="languagesToModify"][value="' + value + '"]').prop("checked", true);
        $('input[name="defaultLanguagesToModify"][value="' + value + '"]').removeClass("d-none");
        $('.optional-languagesToModify-radio-labels[value="' + value + '"]').removeClass("d-none");

        if (value == defaultLanguage) {
            $('input[name="defaultLanguagesToModify"][value="' + value + '"]').prop("checked", true);
            $('.optional-languagesToModify-radio-labels[value="' + value + '"]').addClass("d-none");
            $('.default-languagesToModify-radio-labels[value="' + value + '"]').removeClass("d-none");
        }
    });

    var langId = getCurrentLang();

    var treeSource = clientEvaluationLanguages.map(c => ({
        title: c.name,
        key: 'c_' + c.id,
        "checkbox": true,
        "unselectable": false,
        children: c.clientEvaluations.map(ce => ({
            title: ce.evaluation.translations.find(_ => _.langId == langId).name,
            key: 'ce_' + ce.id,
            "checkbox": true,
            "unselectable": false,
            children: ce.clientEvaluationLanguages.map(cel => ({
                title: cel.language.name,
                key: 'cel_' + cel.id,
                "checkbox": true,
                "unselectable": false,
                "selected": _userClientEvaluationLanguages.find(_ => _ == cel.id) != undefined
            }))
        }))
    }));

    $("#clientEvaluationLanguagesToModify").fancytree({
        source: [],
        selectMode: 3
    });

    $('#clientEvaluationLanguagesToModify').fancytree('getTree').reload([
        {
            title: "Clients", key: "2", children: treeSource
        }
    ]);

    $("#timezoneToModify").val(userTimezone);

    //TODO: Uncomment this section when the "Client admin" role is finally implemented
    //if (userClient.length > 0) {
    //    $("#clientToModify").val(document.getElementById(userClient).value);
    //}
    //showOrHideClientInput("#clientAssignedToClientAdmin", "#roleToModify", "#clientToModify");

    $("#updateUserPartial").dialog({
        buttons: {
            OK: function () {
                var selectedEvaluationLangs = $("#clientEvaluationLanguagesToModify").fancytree("getTree").getSelectedNodes().filter(_ => _.key.includes('cel_')).map(_ => parseInt(_.key.split('cel_')[1]));

                _userClientEvaluationLanguages = selectedEvaluationLangs;

                if ($("#updateUserForm").valid()) {
                    var data = {
                        Id: userId,
                        FirstName: $("#firstNameToModify").val(),
                        LastName: $("#lastNameToModify").val(),
                        PhoneNumber: $("#phoneNumberToModify").val(),
                        Email: $("#emailToModify").val(),
                        RoleId: $("#roleToModify").find(":selected").val(),
                        LanguagesId: $('input[name="languagesToModify"]:checked').map(function () {
                            return parseInt(this.value);
                        }).get(),
                        DefaultLanguageId: parseInt($("input[name=defaultLanguagesToModify]:checked").val()) || 0,
                        TimezoneOffset: $("#timezoneToModify").find(":selected").val(),
                        ClientId: document.getElementById("clientsToModify").querySelector(`[value="${$("#clientToModify").val()}"]`).id,
                        ClientEvaluationLanguageUserIds: _userClientEvaluationLanguages
                    };

                    $.ajax({
                        url: '/api/superadmin/UpdateUser',
                        type: 'POST',
                        data: JSON.stringify(data),
                        contentType: 'application/json; charset=utf-8',
                        success: function (response) {

                            $("#userUpdatedAlert").removeClass("d-none");
                            $("#userUpdatedAlert").removeClass("hide");
                            $("#userUpdatedAlert").addClass("show");
                            setTimeout(function () {
                                $("#userUpdatedAlert").removeClass("show");
                                $("#userUpdatedAlert").addClass("hide");
                                $("#userUpdatedAlert").addClass("d-none");
                            }, 5000);
                        },
                        error: function (xhr) {

                            try {
                                $("#emailToModifyError").html(xhr.responseJSON.errors.Email[0]);
                            } catch (err) { }
                            try {
                                $("#roleToModifyError").html(xhr.responseJSON.errors.RoleId[0]);
                            } catch (err) { }
                            try {
                                $("#languageToModifyError").html(xhr.responseJSON.errors.LanguagesId[0]);
                            } catch (err) { }
                            try {
                                $("#defaultLanguageToModifyError").html(xhr.responseJSON.errors.DefaultLanguageId[0]);
                            } catch (err) { }
                            try {
                                $("#timezoneToModifyError").html(xhr.responseJSON.errors.TimezoneOffset[0]);
                            } catch (err) { }
                            try {
                                $("#clientIdToModifyError").html(xhr.responseJSON.errors.ClientId[0]);
                            } catch (err) { }

                            $("#userNotUpdatedAlert").removeClass("d-none");
                            $("#userNotUpdatedAlert").removeClass("hide");
                            $("#userNotUpdatedAlert").addClass("show");
                            setTimeout(function () {
                                $("#userNotUpdatedAlert").removeClass("show");
                                $("#userNotUpdatedAlert").addClass("hide");
                                $("#userNotUpdatedAlert").addClass("d-none");
                            }, 5000);

                            showOrHideClientInput();

                            //alert(xhr.responseText);
                        }
                    }).done(function () {
                        UpdateUserList();
                    }).fail(function () {
                        UpdateUserList();
                    });
                }
            }
        },
        open: function (e) {

            $(this).parent().addClass("dialog-open");
            $($(this).parent().find(".ui-dialog-buttonset").children()[0]).addClass("btn btn-primary btn-lg");
            $(".ui-dialog-buttonset").addClass("text-center");
        },
        close: function (e) {
            $(this).parent().removeClass("dialog-open");
            $("#evaluatorTestSelectionModeToModify").val("1"); // all
            $("#evaluationFilterClientNameToModify").val("");
        },
    })
};

function changeUserStatus(userId) {

    var data = {
        Id: userId
    };

    $.ajax({
        url: '/api/superadmin/UpdateUserStatus',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        success: function (response) {

            $("#userStatusUpdatedAlert").removeClass("d-none");
            $("#userStatusUpdatedAlert").removeClass("hide");
            $("#userStatusUpdatedAlert").addClass("show");
            setTimeout(function () {
                $("#userStatusUpdatedAlert").removeClass("show");
                $("#userStatusUpdatedAlert").addClass("hide");
                $("#userStatusUpdatedAlert").addClass("d-none");
            }, 5000);

        },
        error: function (xhr) {

            $("#userStatusNotUpdatedAlert").removeClass("d-none");
            $("#userStatusNotUpdatedAlert").removeClass("hide");
            $("#userStatusNotUpdatedAlert").addClass("show");
            setTimeout(function () {
                $("#userStatusNotUpdatedAlert").removeClass("show");
                $("#userStatusNotUpdatedAlert").addClass("hide");
                $("#userStatusNotUpdatedAlert").addClass("d-none");
            }, 5000);

            //alert(xhr.responseText);
        }
    }).done(function () {
    }).fail(function () {
        UpdateUserList();
    });
}

function confirmUserToDelete(userId) {
    $("#userIdToDelete").val(userId);
    $("#deleteModal").modal("show");
}

function deleteUser() {
    var data = {
        Id: $("#userIdToDelete").val()
    };

    $.ajax({
        url: '/api/superadmin/DeleteUser',
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        success: function (response) {

            $("#userDeletedAlert").removeClass("d-none");
            $("#userDeletedAlert").removeClass("hide");
            $("#userDeletedAlert").addClass("show");
            setTimeout(function () {
                $("#userDeletedAlert").removeClass("show");
                $("#userDeletedAlert").addClass("hide");
                $("#userDeletedAlert").addClass("d-none");
            }, 5000);

        },
        error: function (xhr) {

            $("#userNotDeletedAlert").removeClass("d-none");
            $("#userNotDeletedAlert").removeClass("hide");
            $("#userNotDeletedAlert").addClass("show");
            setTimeout(function () {
                $("#userNotDeletedAlert").removeClass("show");
                $("#userNotDeletedAlert").addClass("hide");
                $("#userNotDeletedAlert").addClass("d-none");
            }, 5000);

            //alert(xhr.responseText);
        }
    }).done(function () {
        UpdateUserList();
        $("#userIdToDelete").val("");
        $("#deleteModal").modal("hide");
    }).fail(function () {
        UpdateUserList();
        $("#userIdToDelete").val("");
        $("#deleteModal").modal("hide");
    });
}

function UpdateUserList() {
    $.ajax({
        url: '/superadmin/manage',
        type: 'POST',
        data: {
            __RequestVerificationToken: $("[name='__RequestVerificationToken']").val()
        },
        success: function (response) {
            $("#managePartial").replaceWith(response);
            setTable();
        },
        error: function (xhr) {
            console.log(xhr.responseText);
        }
    })
}

function setTable() {

    var possibleLang = document.cookie.match(new RegExp('(^| )' + '.AspNetCore.Culture' + '=([^;]+)'));

    var cookie = "EN";
    if (possibleLang != null) {
        cookie = possibleLang[2].match(new RegExp('[a-z]{2}'))[0];
        cookie = cookie.toUpperCase();
    }

    var langId = cookie == "EN" ? 2 : 1;

    if (langId == 2) {
        $('#userList').DataTable({
            "columnDefs": [
                { "orderable": false, "targets": 2 },
                { "orderable": false, "targets": 4 }
            ]
        });
    }
    else {
        $('#userList').DataTable({
            "columnDefs": [
                { "orderable": false, "targets": 2 },
                { "orderable": false, "targets": 4 }
            ],
            "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "Lignes _START_ à _END_ sur _TOTAL_",
                "sInfoEmpty": "Aucune ligne affichée",
                "sInfoFiltered": "(Filtrer un maximum de_MAX_)",
                "sInfoPostFix": "",
                "sSearch": "Chercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                    "sFirst": "Premier", "sLast": "Dernier", "sNext": "Suivant", "sPrevious": "Précédent"
                },
                "oAria": {
                    "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
            }
        });
    }
}

function showOrHideClientInput(clientDiv, roleDropdown, clientInput) {
    var selectedRole = $(roleDropdown).find(":selected").text().toLowerCase();

    console.log(selectedRole);

    if (/client/.test(selectedRole)) {

        $(clientDiv).removeClass("d-none");
    }
    else {
        $(clientDiv).addClass("d-none");
        $(clientInput).val("");
    }
}

function showOrHideEvaluationTree(roleDropdown, treeView) {
    var selectedRole = $(roleDropdown).find(":selected").text().toLowerCase();

    if (/evaluator/.test(selectedRole) || /evaluateur/.test(selectedRole)) {
        $(treeView).show();
    }
    else {
        $(treeView).hide();
    }
}

$('#roleToModify').change(function () {
    showOrHideClientInput("#clientAssignedToClientAdmin", "#roleToModify", "#clientToModify");
    showOrHideEvaluationTree("#roleToModify", "#evaluationTreeToModify");
});

$('#role').change(function () {
    showOrHideClientInput("#clientToAssignToClientAdmin", "#role", "#client");
    showOrHideEvaluationTree("#role", "#evaluationTree");
});

//$('#closeModal').click(function () {
//    $('.ui-dialog-content').dialog('close');
//});

$("input[name=languages]").change(function () {
    showOrHideLanguagesRadioButtons(this);
});

$("input[name=defaultLanguages]").change(function () {
    showOrHideLanguagesRadioButtonsLabels(this);
});

$("input[name=languagesToModify]").change(function () {
    showOrHideLanguagesRadioButtons(this, "ToModify");
});

$("input[name=defaultLanguagesToModify]").change(function () {
    showOrHideLanguagesRadioButtonsLabels(this, "ToModify");
});

function showOrHideLanguagesRadioButtons(input, label = "") {

    if ($(input).is(':checked')) {

        $("#Language_" + input.id).removeClass("d-none");
        $("#LabelForOptionalLanguage_" + input.id).removeClass("d-none");

        if ($("input[name=defaultLanguages" + label + "]:checked").length == 0) {
            $("#Language_" + input.id).prop('checked', true);
            $("#LabelForOptionalLanguage_" + input.id).addClass("d-none");
            $("#LabelForDefaultLanguage_" + input.id).removeClass("d-none");
        }
    }
    else {

        $("#Language_" + input.id).addClass("d-none");
        $("#Language_" + input.id).prop('checked', false);
        $("#LabelForOptionalLanguage_" + input.id).addClass("d-none");
        $("#LabelForDefaultLanguage_" + input.id).addClass("d-none");

        if ($("input[name=defaultLanguages" + label + "]:checked").length == 0) {


            var randomInput = $("input[name=defaultLanguages" + label + "]:not(.d-none)")[0];
            if (randomInput != undefined) {
                $(randomInput).prop('checked', true);
                $("#LabelForOptional" + randomInput.id).addClass("d-none");
                $("#LabelForDefault" + randomInput.id).removeClass("d-none");
            }
        }
    }
}

function showOrHideLanguagesRadioButtonsLabels(input, label = "") {
    $(".default-languages" + label + "-radio-labels").addClass("d-none");
    $(".optional-languages" + label + "-radio-labels").each(function (i, obj) {
        if ($("#" + obj.id.split("_")[1]).is(':checked')) {
            $(obj).removeClass("d-none");
        }
    });

    if ($(input).is(':checked')) {

        $("#LabelForDefault" + input.id).removeClass("d-none");
        $("#LabelForOptional" + input.id).addClass("d-none");
    }
    else {
        $("#LabelForDefault" + input.id).addClass("d-none");
        $("#LabelForOptional" + input.id).removeClass("d-none");
    }
}

$("#role").on("change", function () {
    if ($("#role").find(":selected")[0].outerText.indexOf("Eval") >= 0) {
        $('#evaluationTree').show();
    } else {
        $('#evaluationTree').hide();
    }
});